<template>
  <div>
    <NBar title="接收消息的微信"/>
    <div class="top">
      <div class="title">消息通知设置</div>
      <span class="rule" @click="openRule()">规则说明</span>
    </div>
    <div class="content-div">
      <div class="title">
        <span class="title-text">公众号消息</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <div class="img-div">
        <img src="" class="img">
      </div>
      <span class="text"> 账号（15256225680）在公众号端未绑定微信，目前无法通过公众号接收消息。若需使用公众号接收消息，请扫码绑定微信。</span>
    </div>
    <div class="bottom-div">
      <span class="title-text">企业微信消息</span>
      <span class="text">企业微信端绑定微信：操作指引 >></span>
      <div class="bottom-text-div">
        <span>若需查询已绑定的微信，请</span>
        <span class="text">联系客服</span>
      </div>
    </div>
    <nut-dialog title="消息推送方式" :visible="dialogShow" @ok-btn-click="dialogShow=false"
                @cancel-btn-click="dialogShow=false" @close="dialogShow=false" text-align="left" cancel-btn-txt="知道了"
                no-ok-btn="true">
      <div class="content">
        <div class="title">1. 推送优先级</div>
        <span class="text">(1）若未开启 “公众号消息” 开关，或者 开启了“公众号消息开关”、但公众号端未绑定微信的，则系统默认使用企业微信进行消息推送。
        </span>
        <span class="text">(2）若开启了 “公众号消息” 开关、且绑定了微信的，则将会优先使用公众号进行推送。对于部分不支持公众号推送的消息，仍会通过企业微信消息进行推送。
        </span>
      </div>
      <div class="content">
        <div class="title">2. 公众号消息</div>
        <span class="text">(1）“公众号消息”是指通过 “乐摇摇商户平台”公众号推送消息。</span>
        <span class="text">(2）如果开启了“公众号消息”开关，并且成功绑定了微信的，那么，当前账号相关的消息通知（离线消息、故障消息等）将会通过 “乐摇摇商户平台”公众号推送给已绑定的微信。请确保正常关注该公众号，否则将无法正常通过公众号接收消息。</span>
        <span class="text">(3）同一个微信支持绑定多个账号。</span>
      </div>
      <div class="content">
        <div class="title">3. 企业微信消息</div>
        <span class="text">(1）“企业微信消息” 是指通过企业微信推送消息。</span>
        <span class="text">(2）如果在企业微信端成功绑定了微信的，那么，根据“推送优先级”的规则，当前账号下、符合条件的消息将会通过 “企业微信” 推送给已绑定的微信。</span>
        <span class="text">(3）同一个微信仅支持绑定一个账号。</span>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
export default {
  name: 'MessageWeChat',
  data () {
    return {
      dialogShow: false
    }
  },
  methods: {
    openRule () {
      this.dialogShow = true
    }
  }
}
</script>

<style scoped>
  .top {
    margin: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .top .title {
    color: #848484;
  }

  .top .rule {
    color: blue;
  }

  .content-div {
    background-color: #fff;
    padding: 15px;
  }

  .content-div .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .content-div .title .title-text {
    font-size: 16px;
  }

  .content-div .img-div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 15px 0;
  }

  .content-div .img-div .img {
    width: 160px;
    height: 160px;
  }

  .content-div .text {
    color: #666;
  }

  .bottom-div {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    margin: 10px;
    padding: 15px;
  }

  .bottom-div .title-text {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .bottom-div .bottom-text-div {
    display: flex;
    flex-direction: row;
    align-content: center;
    margin-top: 5px;
  }

  .bottom-div .text {
    color: blue;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
    margin-bottom: 10px;
  }

  .content .title {
    margin-bottom: 10px;
    font-weight: 600;
    color: #666;
  }

  .content .text {
    margin-bottom: 10px;
  }

  /deep/ .my-switch.nut-switch {
    border-radius: 3px;
    border-color: #ccc;
    background-color: #ccc
  }

  /deep/ .my-switch.nut-switch .nut-switch-btn {
    border: 2px solid #fff;
    box-shadow: none;
    background-color: #fff;
    border-radius: 3px
  }

  /deep/ .my-switch.nut-switch.nut-switch-active {
    border-color: #3CD3A0;
    background-color: #3CD3A0;
  }

  /deep/ .my-switch.nut-switch.nut-switch-active .nut-switch-btn {
    background-color: #fff
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/MessageWeChat.vue